<template>
  <cTable :fields="fields" :header="header" :methods="methods" :config="config">
    <template slot="header">
      <h3 style="padding-bottom: 10px">
        {{ $t("quantity_analysis") }}:{{ resuletNum }}
      </h3>
    </template>
  </cTable>
</template>

<script>
import { getDetails, exportAnalysis } from "@/api/analysis/list";
// import { getCountry } from "@/api/system/country";
// import { getChannel } from "@/api/tracker/channel";

import cTable from "@/base/common/index";
export default {
  name: "analysisResult",

  components: {
    cTable,
  },
  data() {
    return {
      resuletNum: 0,
      methods: {
        list: getDetails,
        exportAnalysis,
        afterHandleList: ({ data }) => {
          this.resuletNum = data.queueTotal;
        },
      },
      config: {
        height: 630,
      },
      header: {
        btns: {
          list: [
            {
              name: () => this.$tz('刷新'),
              type: 'refresh',
              fnName: 'refresh',
              bind: {
                type: 'primary'
              },
            },
          ],
          methods: {
            refresh() {
              this.getList()
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("operate"),
          key: "operate_name",
          align: "center",
          width: 130,
        },
        {
          name: () => this.$t("expTime"),
          key: "create_time",
          align: "center",
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            },
          },
          width: 170,
        },
        {
          type: "btns",
          width: 100,
          name: () => this.$t("excel_path"),
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            export({ row }) {
              if (!row.excel_path) {
                this.$Message["error"]({
                  background: true,
                  content: this.$t("export_tips_msg"),
                  duration: 5,
                });
                return;
              }
              window.open(this.$globalUrl + row.excel_path);
            },
          },
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          align: "center",
          width: 180,
        },
        {
          name: () => this.$t("inbound_time"),
          key: "arrival_warehouse",
          align: "center",
          width: 180,
        },
        {
          name: () => this.$t("channel_code"),
          key: "channel_code",
          align: "center",
          width: 100,
        },

        {
          name: () => this.$t("cod_type"),
          key: "cod_type",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("clientName"),
          key: "clientName",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("keyword"),
          key: "keywords",
          align: "center",
        },
      ],
    };
  },
};
</script>
